import React from 'react'
import { Card } from 'react-toolbox/lib/card'
import styles from './styles.scss'
import T from 'i18n-react'
import { Flex } from 'reflexbox'

import Actions from './Actions'
import {
  default as Collapse,
} from 'components/fulcrum/collapse/Collapse'
import CardLoading from 'components/display/CardLoading'
import ImportDialog from './ImportDialog'
import CardHeader from 'components/custom/Card/CardHeader'
import RevisionDialog from './RevisionDialog'
import Spreadsheet from 'components/fulcrum/spreadsheet/index'
import {
  FETCH_SPECIFICATIONS,
} from './constants'


const SectionCard = (props) => {
  const lastUpdated = (selectedRevisionNumber, name, date) => {
    const revision = 'Revision ' + selectedRevisionNumber + ', '
    const message = 'last updated by ' + name + ' on ' + date
    return(
      <div className={styles.lastUpdated}>
        <span>{revision}</span>
        <span>{message}</span>
      </div>
    )
  }

  const onSubmit = () => {
    const {
      editMode,
      productSpecs,
      onSave,
      match: {
        params: {
          id
        }
      }
    } = props
    if (editMode) onSave(id, productSpecs)
  }
  
  const {
    collapse,
    toggleCollapse,
    toggleRevisionDialog,
    revisionDialogActive,
    importDialogActive,
    toggleImportDialog,
    editMode,
    isLoading,
    toggleEditMode,
    importSkusList,
    fetchImportSummary,
    importSpecification,
    specRevisions,
    selectedRevisionNumber,
    onRevisionChange,
    formattingRanges,
    productSpecs,
    lastUpdatedUser,
    lastUpdatedDate,match: {
      params: {
        id
      }
    }
  } = props

  return (
    <Card theme={styles}>
      <CardHeader title={T.translate('containers.product.view.index.navigation.specifications')}>
        <Actions
          collapse={collapse}
          editMode={editMode}
          toggleCollapse={toggleCollapse}
          toggleRevisionDialog={toggleRevisionDialog}
          toggleImportDialog={toggleImportDialog}
          toggleEditMode={toggleEditMode}
          onSubmit={onSubmit}
          isLoading={isLoading}
        />
      </CardHeader>
      {lastUpdated(selectedRevisionNumber, lastUpdatedUser, lastUpdatedDate)} 
      <br />

      <RevisionDialog 
        revisionDialogActive={revisionDialogActive}
        toggleRevisionDialog={toggleRevisionDialog}
        revisions={specRevisions}
        selectedRevisionNumber={selectedRevisionNumber}
        onRevisionChange={onRevisionChange}
      />
      <ImportDialog 
        importDialogActive={importDialogActive}
        toggleImportDialog={toggleImportDialog}
        fetchImportSummary={() => fetchImportSummary(id)}
        importSkusList={importSkusList}
        importSpecification={importSpecification}
        selectedRevisionNumber={selectedRevisionNumber}
      />
    
      <Spreadsheet 
        list={productSpecs}
        editMode={editMode}
        selectedRevisionNumber={selectedRevisionNumber}
        formattingRanges={formattingRanges}
        isLoading={isLoading}
      />
    </Card>
  )
}

export default SectionCard
